module.exports = __webpack_public_path__ + "img/np.3ce0600.svg";